<div class="py-4">
    <div class="py-4">
        <app-solicitud-servicio 
            [title]="'Solicitud de servicio'" 
            [submitted]="submitted" 
            (SolicitudEvent)="catchRequestService($event)" 
            [$views]="1">
        </app-solicitud-servicio>
    </div>

    <div class="container d-flex flex-row-reverse">
        <div class="col-2">
            <button type="button" class="btn btn-secondary col-12" 
            (click)="saveRequestService()">
                SOLICITAR
            </button>
        </div>
    </div>
</div>